<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      Утвержден Приказом Председателя<br />
      Агентства Республики Казахстан<br />
      по делам строительства и<br />
      жилищно-коммунального хозяйства<br />
      от 29 декабря 2011 года № 536<br />
      <br />
      Сборник нормативно-технической<br />
      и исполнительной документации,<br />
      необходимой при проведении<br />
      строительно-монтажных работ<br />
      (паспорт строительства)<br />
      <br />
      Приложение 9
    </div>
    <div class="chapter-title">Журнал монтажных работ</div>
    <n-items v-if="project">
      <n-input title="Строительная организация" v-bind="$form.input('executor')" :text="!editable" />
      <n-input title="Строительство" v-bind="$form.input('projectTitle')" :text="!editable" />
      <n-input title="Начат" v-bind="$form.input('startedAt')" :text="!editable" />
      <n-input title="Окончен" v-bind="$form.input('endedAt')" :text="!editable" />
      <div style="width: 100%">Основные данные:</div>
      <n-input title="Расчетный пролет, м" v-bind="$form.input('fly')" :text="!editable" inline />
      <n-input title="Высота, м" v-bind="$form.input('height')" :text="!editable" inline />
      <n-input title="Длина, м" v-bind="$form.input('long')" :text="!editable" inline />
      <n-input title="Способ производства работ" v-bind="$form.input('workWay')" :text="!editable" />
      <n-input title="Тип и грузоподъемность монтажного оборудования" v-bind="$form.input('typeLoadCapacity')" :text="!editable" />
      <n-input title="Организация, разработавшая рабочую документацию" v-bind="$form.input('projector')" :text="!editable" />
      <n-input title="Организация, разработавшая проект производства работ" v-bind="$form.input('projectorWork')" :text="!editable" />
      <n-input title="Предприятие, разработавшее чертежи КМД и изготовившее конструкции" v-bind="$form.input('projectorKmd')" :text="!editable" />
      <n-input title="Объемы работ: стальные конструкции, т" v-bind="$form.input('workValue')" :text="!editable" />
      <n-input title="Сборные железобетонные конструкцииб м3" v-bind="$form.input('prefabricatedMetal')" :text="!editable" />
      <n-input title="Ответственные за монтажные работы и ведение журнала " v-bind="$form.input('responsible')" :text="!editable" />
      <n-button color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
